import { Avatar, IconButton, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useGetCurrentUserInfoQuery } from '../../../store/api/userApi'
import { updateUserInfo } from '../../../store/slice/mainToCardSlice'
import { useDispatch, useSelector } from 'react-redux'
import { updateOrderBuId } from '../../../store/slice/persistSlice'


const ProfileIcon = () => {
    const { data, isLoading } = useGetCurrentUserInfoQuery();

    const dispatch = useDispatch();
    useEffect(() => {
        if (!isLoading && data) {
            dispatch(updateUserInfo(data?.data))
        }
    }, [isLoading, data, dispatch])


    const userInfo = useSelector(state => state.mainToCard.userInfo)

    useEffect(() => {
        dispatch(updateOrderBuId(userInfo.defaultBusinessUnitId))
    }, [userInfo?.defaultBusinessUnitId, dispatch, userInfo])


    return (
        <>
            <Link to={`/user/${userInfo.userId}`} style={{ color: 'inherit', textDecoration: 'inherit' }}>
                <IconButton color="inherit">
                    <Avatar src={userInfo?.userPhoto || ''} sx={{ width: 30, height: 30 }} />
                    <Typography variant='h6' sx={{ pl: 2 }}>{userInfo.fullName}</Typography>
                </IconButton>
            </Link>
        </>
    )
}

export default ProfileIcon